import { OffboardingClient } from './offboarding-client';
import { Deserializable } from '../deserializable';
import { OffboardingStep } from './offboarding-step';

export class OffboardingClientListResponse implements Deserializable {
  clients: OffboardingClient[];
  steps: OffboardingStep[];

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
